export default "__VITE_ASSET__B9LOSDFf__"